<form class="search-form">
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
        <mat-label>Search Anything</mat-label>
        <input type="text" matInput [formControl]="inputControl" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete"
                          [displayWith]="displayFn"
                          (optionSelected)="onOptionSelected($event)">
            @for (option of filteredOptions | async; track option) {
                <mat-option [value]="option">
                    <span class="option-label">
                        <span class="material-symbols-rounded">{{ option.materialSymbolsIcon || "code" }}</span>
                        <span>{{ option.text }}</span>
                    </span>
                </mat-option>
            }
        </mat-autocomplete>
    </mat-form-field>
</form>
